import React, { useEffect, useRef, useSyncExternalStore } from "react";
import {
  getAlertSoundSnapshot,
  retryBlockedAlertSounds,
  subscribeAlertSound,
} from "../../Utils/alertSoundGuard";
import { useAnnounce } from "../LiveAnnouncer/LiveAnnouncer";
import { useLostFocusReturn } from "../../Hooks/useLostFocusReturn";
import "./alertsoundbanner.css";

const ALERT_SOUND_ON_ANNOUNCEMENT = "Alert sound turned on.";

const enclosingDialog = (element) =>
  element.closest('[role="dialog"], [role="alertdialog"]');
const dialogTargets = (dialog) => (dialog ? [dialog] : []);

function AlertSoundBanner() {
  const { blocked, loadFailed } = useSyncExternalStore(
    subscribeAlertSound,
    getAlertSoundSnapshot,
  );
  const announce = useAnnounce();
  const bannerRef = useRef(null);
  const wasBlockedRef = useRef(blocked);

  useLostFocusReturn(bannerRef, {
    keyOf: enclosingDialog,
    targetsFor: dialogTargets,
  });

  useEffect(() => {
    const wasBlocked = wasBlockedRef.current;
    wasBlockedRef.current = blocked;
    if (wasBlocked && !blocked && !loadFailed) {
      announce(ALERT_SOUND_ON_ANNOUNCEMENT);
    }
  }, [blocked]);

  if (loadFailed) {
    return (
      <div ref={bannerRef} className="alert-sound-banner">
        <span role="alert">
          An alert sound failed to load, so alarms may be silent. Reload the
          page when it is safe to do so.
        </span>
      </div>
    );
  }

  if (!blocked) return null;

  return (
    <div ref={bannerRef} className="alert-sound-banner">
      <span role="alert">The browser blocked an alert sound.</span>
      <button
        type="button"
        className="alert-sound-banner-button"
        onClick={retryBlockedAlertSounds}
      >
        Turn on alert sound
      </button>
    </div>
  );
}

export default AlertSoundBanner;
